<template>
  <div class="widthFull container logo dataContainer" >



			<h1 class="h2 center mt-5 pb-4"><b></b>ATTENZIONE!</h1>


			<!-- ROW 1 ******************************************************************************************************* -->
      <h1 class="h2 center mt-5 pb-4 red"><b>Il programma di incentivazione  <br/> è terminato il 31 luglio 2020.</b></h1>


  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import { USER_REQUEST, USER_SET_DEFAULT_SHIP_DATA } from 'actions/user'
import Datepicker from 'vuejs-datepicker'
import {it} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'







const moment = require('moment')


export default {
  name: 'play',
	components: {
			Datepicker,
			VueTimepicker,
	},
	data () {
    return {
			loadingState: false,
			userToken: '',
			partita_iva: '',
			existPIVA: false,
			existEmail: false,
			existCF: false,
			tempIva: '',
			tempCF: '',
			tempEmail: '',
			azienda: '',
			name: '',
			lastname: '',
			email: '',
			phone: '',
			cellulare: '',
			codice_fiscale: '',
			shipEqual: true,
			shipData: {},
			address: '',
			civic: '',
			region: '',
			province: '',
			city: '',
			zip: '',
			regions: [],
			regionsState: true,
			provincies: [],
			provinciesState: false,
			cities: [],
			citiesState: false,
			zips: [],
			zipsState: false,
			provinceError: false,
			cityError: false,
			zipError: false,

			ship_regions: [],
			ship_regionsState: true,
			ship_provincies: [],
			ship_provinciesState: false,
			ship_cities: [],
			ship_citiesState: false,
			ship_zips: [],
			ship_zipsState: false,
			ship_provinceError: false,
			ship_cityError: false,
			ship_zipError: false,


			ship_name: '',
			ship_lastname: '',
			near: '',
			ship_phone: '',
			ship_cellulare: '',
			ship_address: '',
			ship_civic: '',
			ship_region: '',
			ship_province: '',
			ship_city: '',
			ship_zip: '',
			note: '',


      invoiceFront: '',
  		invoiceFrontName: '',
  		invoiceFrontBucket: '',
  		uploadFrontPercentage: 0,
  		invoiceRear: '',
  		invoiceRearName: '',
  		invoiceRearBucket: '',
  		uploadRearPercentage: 0,
      id_eps: '',

			vw: window.innerWidth,
    }
  },
	methods: {

		registration: function() {
			this.$validator.validate().then(valid => {
				if (valid && this.profile.email && this.profile.id) {

          var data = {
            name: this.name,
      			cognome: this.lastname,
      			email:  this.email,
      			password: this.profile.password,
      			azienda:  this.azienda,
      			id_eps: '',
      			target: 0,
            partita_iva: this.partita_iva,
      			codice_fiscale: this.codice_fiscale,
      			indirizzo: this.address,
      			civico: this.civic,
      			comune:  this.city.city,
      			provincia:  this.province,
      			regione:  this.region.text,
      			cap:  this.zip,
      			telefono:  this.phone,
      			cellulare:  this.cellulare,
      			privacy: 1,
      			privacy1: this.invoiceFrontBucket,
      			privacy2: this.invoiceRearBucket,

      			ship_presso:  this.near,
      			ship_note:  this.note,
      		  ship_name: this.shipEqual ?  this.name : this.ship_name,
      			ship_cognome: this.shipEqual ?  this.lastname : this.ship_lastname,
      			ship_indirizzo: this.shipEqual ?  this.address : this.ship_address,
      			ship_civico: this.shipEqual ?  this.civic : this.ship_civic,
      			ship_comune: this.shipEqual ?  this.city.city : this.ship_city.city,
      			ship_provincia: this.shipEqual ?  this.province : this.ship_province,
      			ship_regione: this.shipEqual ?  this.region.text : this.ship_region.text,
      			ship_cap: this.shipEqual ?  this.zip : this.ship_zip,
      			ship_telefono: this.shipEqual ?  this.phone : this.ship_phone,
      			ship_cellulare: this.shipEqual ?  this.cellulare : this.ship_cellulare,

            type: this.profile.email,
            confirmed: this.profile.id,
            id_eps: this.id_eps,

          }

          console.log(data)



          axios({
            url: process.env.ROOT_API + 'api/newUser',
            method: 'POST',
            data: {
              user: data,
              regType: 'new',
              who: this.profile.email,
              operator_id: this.profile.id,
            },
            headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
          .then(resp => {

            this.addClientSuccess()
            this.$router.push('/')

          })
          .catch(error => {

            var text = error.response.data.error
            this.addClientError(text)

          })





				}else{
          if ( !this.profile.email ){
            alert( 'Sessione scaduta - devi effetuare login' )
          }
        }

			})

		},

			checkIfExistUser: function(value){

						const newValue = value.target.value
						const field = this.$validator.fields.find({ name: 'partita_iva'});
						var typeCall
						var tempVal
						if ( value.target.id == 'partita_iva' ){
							typeCall = 'partita_iva'
							tempVal = this.tempIva
						}
						if ( value.target.id == 'codice_fiscale' ){
							typeCall = 'codice_fiscale'
							tempVal = this.tempCF
						}
						if ( value.target.id == 'email' ){
							typeCall = 'email'
							tempVal = this.tempEmail
						}

						if ( !this.errors.has(value.target.id) && tempVal != newValue && newValue ){

							if ( typeCall == 'partita_iva' ){
								this.tempIva = newValue
							}
							if ( typeCall == 'codice_fiscale' ){
								this.tempCF = newValue
							}
							if ( typeCall == 'email' ){
								this.tempEmail = newValue
							}

							axios({
								url: process.env.ROOT_API + 'api/checkExUser',
								method: 'POST',
								data: {
									value: newValue,
									typeCall: typeCall,
								},
								headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
							.then(resp => {

								if ( typeCall == 'partita_iva' ){
									this.existPIVA = false
								}
								if ( typeCall == 'codice_fiscale' ){
									this.existCF = false
								}
								if ( typeCall == 'email' ){
									this.existEmail = false
								}

							})
							.catch(error => {

								if ( typeCall == 'partita_iva' ){
									this.existPIVA = true
								}
								if ( typeCall == 'codice_fiscale' ){
									this.existCF = true
								}
								if ( typeCall == 'email' ){
									this.existEmail = true
								}

							})
						}

			},

		uploadFile: function(input){
			var file = input.target.files[0].name
      this.invoiceFrontName = file
			var extension = file.substr( (file.lastIndexOf('.') +1) ).toLowerCase()
			var size = input.target.files[0].size

			if ( ( extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf' ) && size < 10240000 ){

				this.invoiceFront = input.target.files[0].name

				var formData = new FormData();
				var _vue = this // << here
				formData.append('fattura0', input.target.files[0]);

				axios.post( process.env.ROOT_API + 'api/uploadImageInvoice',
					formData,
					{
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer '+ process.env.AUTH_TOKEN,
					},
					onUploadProgress: function( progressEvent ) {
						this.uploadFrontPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
					}.bind(this)
					}
				).then(function(e){
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if( regex .test(e.data.fattura)) {
						_vue.uploadFrontPercentage = 0
						_vue.invoiceFrontBucket = e.data.fattura
					}else{
						_vue.uploadFrontPercentage = 0
						_vue.invoiceFront = ''
						_vue.invoiceFrontBucket = ''
						_vue.UploadError()
						input.target.value = null
					}

				})
				.catch(function(){
					_vue.uploadFrontPercentage = 0
					_vue.invoiceFront = ''
					_vue.invoiceFrontBucket = ''
					_vue.UploadError()
					input.target.value = null

				});
			}

		},


		uploadFileRear: function(input){
			var file = input.target.files[0].name


      this.invoiceRearName = file
			var extension = file.substr( (file.lastIndexOf('.') +1) ).toLowerCase()
			var size = input.target.files[0].size

			if ( ( extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf' ) && size < 10240000 ){
				this.invoiceRear = input.target.files[0].name

				var formData = new FormData();
				var _vue = this // << here
				formData.append('fattura0', input.target.files[0]);

				axios.post( process.env.ROOT_API + 'api/uploadImageInvoice',
					formData,
					{
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer '+ process.env.AUTH_TOKEN,
					},
					onUploadProgress: function( progressEvent ) {
						this.uploadRearPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
					}.bind(this)
					}
				).then(function(e){
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if( regex .test(e.data.fattura)) {

						_vue.uploadRearPercentage = 0
						_vue.invoiceRearBucket = e.data.fattura
					}else{
						_vue.uploadRearPercentage = 0
						_vue.invoiceRear = ''
						_vue.invoiceRearBucket = ''
						_vue.UploadError()
						input.target.value = null
					}

				})
				.catch(function(){
					_vue.uploadRearPercentage = 0
					_vue.invoiceRear = ''
					_vue.invoiceRearBucket = ''
					_vue.UploadError()
					input.target.value = null

				});
			}

		},


    addClientSuccess(){
			this.$swal({
				type: 'success',
				title: '<strong class="modalText ">L`installatore registrato con successo </strong>',
				html: '',
				confirmButtonText:  'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267',
			});
		},

    addClientError(text){
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Registrazione non andato a buon fine.</strong>',
				html: text,
				confirmButtonText:  'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267',
			});
		},



		UploadError(){
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
				html: '',
				confirmButtonText:  'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267',
			});
		},


		populateRegions: function () {
			axios({
				url: process.env.ROOT_API + 'api/getRegions',
				method: 'POST',
				headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
			.then(resp => {
				this.regions = resp.data.regions;
				this.regionsState = false

				this.ship_regions = resp.data.regions;
				this.ship_regionsState = false

			})
			.catch(resp => {
				this.regions = [];
				this.regionsState = false

				this.ship_regions = [];
				this.ship_regionsState = false
			})
		},

		checkRegion: function () {

			const { region } = this
			if ( region ){
				this.provinceError = false
			}else{
				this.provinceError = true
			}

		},
		checkProvince: function () {

			const { province } = this
			if ( province ){
				this.cityError = false
			}else{
				this.cityError = true
			}

		},
		checkZip: function () {
			const { city } = this
			if ( city ){
				this.zipError = false
			}else{
				this.zipError = true
			}
		},

		ship_checkRegion: function () {

			const { ship_region } = this
			if ( ship_region ){
				this.ship_provinceError = false
			}else{
				this.ship_provinceError = true
			}

		},
		ship_checkProvince: function () {

			const { ship_province } = this
			if ( ship_province ){
				this.ship_cityError = false
			}else{
				this.ship_cityError = true
			}

		},
		ship_checkZip: function () {
			const { ship_city } = this
			if ( ship_city ){
				this.ship_zipError = false
			}else{
				this.ship_zipError = true
			}
		},

		calcToDate(){
			var start = process.env.START_DATE
			var date = new Date(new Date().setDate(new Date().getDate() - 5))
			var startDate = new Date(start.year, start.month - 1, start.day)
			if ( startDate > date ){
				var finalTo = startDate
			}else{
				var finalTo = date
			}
			return finalTo
		},
		calcFromDate(){
			var stopObj = process.env.STOP_DATE
			var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1)
			var nowDate = new Date()
			if ( nowDate <=  stopDate ){
				var finalFrom = nowDate
			}else{
				var finalFrom = stopDate
			}
			return finalFrom
		},

		handleResize: function(){
			this.vw = window.innerWidth
		}

    },
	watch: {
		azienda: function(value){
			this.azienda = value.toUpperCase()
		},
    name: function(value){
			this.name = value.toUpperCase()
		},
    lastname: function(value){
			this.lastname = value.toUpperCase()
		},
    ship_name: function(value){
			this.ship_name = value.toUpperCase()
		},
    ship_lastname: function(value){
			this.ship_lastname = value.toUpperCase()
		},
		number: function(value){
			this.number = parseInt(value)
		},
    phone: function(val){
			if ( val ){
				this.phone = val.replace(/\D+/g, '');
			}
		},
    id_eps: function(val){
      if ( val ){
        this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function(val){
			if ( val ){
				this.cellulare = val.replace(/\D+/g, '');
			}
		},
    ship_phone: function(val){
			if ( val ){
				this.ship_phone = val.replace(/\D+/g, '');
			}
		},
    ship_cellulare: function(val){
			if ( val ){
				this.ship_cellulare = val.replace(/\D+/g, '');
			}
		},
		region: function(newVal){
			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = ''
			this.cityError = false
			this.provinceError = false
			this.zipError = false
			this.province = ''
			this.provincies = []
			this.provinciesState = true

				const { provincies, provinciesState } = this
				axios({
					url: process.env.ROOT_API + 'api/getProvincies',
					method: 'POST',
					data: {
						region: newVal.id
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.provincies = resp.data.provincies;
					this.provinciesState = false

				})
				.catch(resp => {
					this.provincies = [];
					this.provinciesState = false
				})

		},
		ship_region: function(newVal){
			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = ''
			this.ship_cityError = false
			this.ship_provinceError = false
			this.ship_zipError = false
			this.ship_province = ''
			this.ship_provincies = []
			this.ship_provinciesState = true

				const { ship_provincies, ship_provinciesState } = this
				axios({
					url: process.env.ROOT_API + 'api/getProvincies',
					method: 'POST',
					data: {
						region: newVal.id
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.ship_provincies = resp.data.provincies;
					this.ship_provinciesState = false

				})
				.catch(resp => {
					this.ship_provincies = [];
					this.ship_provinciesState = false
				})

		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		province: function (newProvince) {
			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = ''
			this.cityError = false
			this.zipError = false

			if ( newProvince ){
				this.citiesState = true
				axios({
					url: process.env.ROOT_API + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.cities = resp.data.cities
					this.citiesState = false
				})
				.catch(resp => {
					this.cities = [];
					this.citiesState = false
				})
			}

		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_province: function (newProvince) {
			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = ''
			this.ship_cityError = false
			this.ship_zipError = false

			if ( newProvince ){
				this.ship_citiesState = true
				axios({
					url: process.env.ROOT_API + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.ship_cities = resp.data.cities
					this.ship_citiesState = false
				})
				.catch(resp => {
					this.ship_cities = [];
					this.ship_citiesState = false
				})
			}

		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		city: function (newCity) {
			this.zipError = false
			this.zips = [];
			this.zip = '';

			if ( newCity.cityistat ){
				this.zipsState = true
				axios({
					url: process.env.ROOT_API + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.zips = resp.data.zips;
					this.zipsState = false
				})
				.catch(resp => {
					this.zips = [];
					this.zipsState = false
				})
			}

		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_city: function (newCity) {
			this.ship_zipError = false
			this.ship_zips = [];
			this.ship_zip = '';

			if ( newCity.cityistat ){
				this.ship_zipsState = true
				axios({
					url: process.env.ROOT_API + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
				.then(resp => {
					this.ship_zips = resp.data.zips;
					this.ship_zipsState = false
				})
				.catch(resp => {
					this.ship_zips = [];
					this.ship_zipsState = false
				})
			}

		},
		vw: function(){

		}

	},
	updated: function(){


	},
  created: function(){
    this.$validator.extend(
    		  'notZeros',{
    		   getMessage: field => ' Il campo Numero di telefono non ha un formato valido.',
    		   validate: (value) => {
    		     // value must be > zero
    		     if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000  ) return true;
    		     return false;
    		   }
    		 });
  },
	mounted: function(){

		window.addEventListener('resize', this.handleResize);
		this.handleResize();

		this.lastnamex = this.getProfile.cognome
		this.xuserx = this.getProfile.name


		var _vue = this

		setTimeout(function(){

			_vue.populateRegions(),
			_vue.disabledDates = {
				to: _vue.calcToDate(), // Disable all dates up to specific date
				from: _vue.calcFromDate(), // Disable all dates after specific date
			}

			_vue.scrollFinished = true

		},1500)

	},
	computed: {
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        profile: state => state.user.profile,
      })
    },


  }






</script>

<style lang="scss" scoped>

$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;


.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle{
  font-size: 47px;
  color: #003d13;

  @media screen and (max-width: $phone) {
    font-size: 27px;
  }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: .4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5{

  @media screen and (max-width: $phone) {
    font-size: 14px;
  }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      text-align: center;
      > img{
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
      }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter{
  align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

  position: relative;
    margin: 0 auto;
    display: block;
    height: 147px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

  @media screen and (max-width: $tablet) {
    margin-top: 15px!important;
  }


  > .fileInputLabel{
    display: none;
  }

  > .invalid-feedback {
    display: block;
    position: absolute;
        bottom: 15px;
    font-weight: 800;
  }

  > input{
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
    left: 5px;
    width: 100%;
    height: 200px;
    z-index: 10;
    top: -20px;
  }

  > label {
    /*display: none;*/

    width: 100%;
    margin: 0 auto;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    position: relative;
    padding: 0!important;
    left: 0;

    > span {
      background-color: #dee6ff;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: 1px solid white;
      width: 192px;
      margin-top: 19px !important;
      display: block;
      height: 155px;
      margin: 0 auto;
      cursor: pointer;
      word-break: break-all;
      padding: 5px;
      color: white;
      border-radius: 7px;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 29px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      align-self: center;
      vertical-align: middle;
      margin: auto auto;
      display: inline-grid;
      background-size: cover;
  background-position: center;

      &:before{
          content: "+";
          display: block;
          clear: both;
          text-align: center;
          height: 141px;
          width: 179px;
          border-radius: 7px;
          padding-top: 51px;
          font-size: 51px;
          font-weight: 600;
          color: #00917e;
          border: 3px solid #00917e;
      }


      @media screen and (max-width: $phone) {
        margin: 0 auto!important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important;
        float: none;
      }



    }

    &:after {
      content: "";
      display: block;

      clear: both;
      text-align: center;
      width: 237px;
      font-size: 10px;
      text-decoration: underline;
      color: black;

/*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

      @media screen and (max-width: $phone) {
        margin: 0 auto!important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important;
        float: none;
      }


    }


    @media screen and (max-width: $phone) {
      width: 100%!important;
      float: none!important;
      text-align: center!important;
      margin-bottom: 40px!important;
      margin: 0 auto!important;
    }
    @media screen and (min-width: $phone) and (max-width: $tablet) {
      width: 100%!important;
      float: none!important;
      text-align: center!important;
      margin-bottom: 40px!important!important;
      margin: 0 auto!important;
    }





  }

}

  .center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>


<style lang="css" scoped>
.sweetText {
  font-size: 26px;
}
	.imageIcons {
		vertical-align: bottom!important;
		width: 50px;
	}


  .hSize {
    font-size: 33px!important;
}

	.howPlayTextCont[data-v-54f59cc7] {
		max-width: 333px;
		text-align: left;
		margin: 0 auto;
		line-height: 27px;
		padding-left: 61px;
	}


	/* new PRICE */

	.swal2-popup .swal2-title, #swal2-content {
		color: #fffbde!important;
		display: block!important;
	}

	.replaceButton{
		max-width: 40px;
	}

	.inputHelper{
    margin-top: -32px;
    color: #0e3d8b;
    font-size: 16px;
    left: 0;
	}

	.priceVal, .priceCent{
		width: calc(50% - 1.5vw - 7.5px);
		display: inline-table;
	}

	.pseudoEuro {
		position: absolute;
		top: 6px;

	}
	.pseudoCent {
		position: absolute;
		top: 6px;
		right:0;

	}

	.group input:focus + .pseudoEuro {
		display:block;
	}

	.group .valid + .pseudoEuro{
		display:block;
	}

	.group input:focus + .pseudoCent {
		display:block;
	}

	.group .valid + .pseudoCent{
		display:block;
	}

	.euroInput{
		position: relative;
		width:200%;
		z-index: 4;
	}

	.euroInput::before{
		content: 'Euro';
	}

	.euroInput:focus, .euroInput.valid{
		width:100%;
	}

	.euroInput:focus::before, .euroInput.valid::before{
		content: 'Euro';
		color: white;
		position: absolute;
	}


	.table{
		display: table;
	}

	.newPriceLabel{
		z-index: 5;
		background: white;
		margin-left: -5px;
		padding-left: 5px;
		overflow: initial;
		min-width: calc(200% + 17px);
	}


	/*  ------------ */

	.image-margin0{
		margin: 0!important;
	}



	.helper{
		color: #0e3d8b;
		font-size: 23px;
		font-family: Oswald-Medium;
	}

	.greyDesc2{
		font-size: 1.1vw;
		color: #fffbde;
	}

	.redDesc{
		font-size: 1.1vw;
		text-decoration: underline;
		cursor: pointer;
	}

	.uploadDone {
		position: absolute;
		top: 10px;
		right: 0;
		color: #a1614f;
	}

	.helperUnderline {

	}

	.labelFileInput{
		top: -20px!important;
		font-size: 22px;
		color: #000000;
	}

	.fileInput{
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		padding: 0;
		top: 17px;
		border-bottom: none;
		color: #000000;
	}

	.fileInputLabel{
		z-index: 3;
		white-space: nowrap;
		overflow: hidden;
		padding-right: 20px;
		text-overflow: ellipsis;
		color: #fffbde;
	}

	.removeProduct{
		position: absolute;
		right: 21px;
		margin: 0px!important;
		top: 48px;
		color: #e7201d;
	}

	.typeDisabled{
		color: #676767;
		cursor: pointer;
	}

	.typeSelected {
		color: #fffbde!important;
		cursor: pointer;
	}



	@media (min-width: 20px) and (max-width: 767px) {

    .inputHelper {
      margin-top: -12px;
      color: #0e3d8b;
      font-size: 16px;
      left: 0;
    }

    .hSize {
      font-size: 19px!important;
    }
    .sweetText {
      font-size: 19px;
    }
    .removeProduct{
    position: absolute;
    right: 21px;
    margin: 0px!important;
    top: 26px;
    color: #e7201d;
}

		.greyDesc2, .redDesc{
			font-size: 3.1vw;
		}

		.fluid {
			max-width: 107px;
		}

		.mobTQ{
			font-size: 23px;
		}

		.smMob{
			font-size: 1rem;
		}

		.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7] {
			max-width: 350px;
			text-align: left;
			margin: 0 auto;
			line-height: 27px;
			padding-left: 43px;
			font-size: 17px;
		}


		.helper {
			color: #0e3d8b;
			font-size: 18px;
			font-family: Oswald-Medium;
		}
		.imageIcons {
			vertical-align: bottom!important;
			width: 39px;
		}
		.fileInput {

			top: 8px!important;

		}


	}


	@media (min-width: 768px) and (max-width: 1205px) {

		.disabledDatesMessage{
			 top: -250%;
		}

	}






</style>



// WEBPACK FOOTER //
// src/components/end/index.vue